import { HLJ_STATISTIC } from '@util'
import cls from 'classnames'
import { message } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import {
  CASE_CONTENT_IMAGE_LIMIT,
  UNINO_PHOTO_LIMIT
} from '../../../../constants'
import VideoUploader from '../VideoUploader'
import style from './index.module.less'

@observer
class Index extends Component {
  statisticFunction = element_tag => {
    HLJ_STATISTIC({
      event_type: 'element_hit',
      ndevice: '0',
      element_tag
    })
  }

  render() {
    const { store, _meal_type, handleChangeScrollAndPosition } = this.props
    const {
      addCaseContentTitle,
      addCaseContentImg,
      addCaseContentVideo,
      property_id,
      imgNum,
      showKeZhao,
      kezhaoLen,
      videoNum
    } = store

    return (
      <div className={style.selection}>
        <div className={style.tipTitle}>图片介绍</div>
        <div className={style.contentWrap}>
          <div
            className={style.content}
            onClick={() => {
              this.statisticFunction('example_photo_add')

              addCaseContentTitle(undefined, handleChangeScrollAndPosition)()
            }}
          >
            <i className={`${style.icons} iconfont icon-addtext`} />
            <div className={style.upload}>添加文字</div>
          </div>
          <div
            className={cls(
              style.content,
              imgNum >= CASE_CONTENT_IMAGE_LIMIT ? style.contentDisabled : ''
            )}
            onClick={() => {
              if (imgNum >= CASE_CONTENT_IMAGE_LIMIT) {
                message.error(`最多上传${CASE_CONTENT_IMAGE_LIMIT}张图片`)
                return
              }
              this.statisticFunction('example_word_add')
              addCaseContentImg()
            }}
          >
            <i className={`${style.icons} iconfont icon-tianjiatupian`} />
            <div className={style.upload}>
              上传图片({imgNum || 0}/{CASE_CONTENT_IMAGE_LIMIT})
            </div>
          </div>
          {(property_id == 8 || property_id == 11) && (
            <VideoUploader
              onChange={addCaseContentVideo}
              onClick={() => {
                this.statisticFunction('example_video_add')
              }}
            >
              <div
                className={cls(
                  style.content,
                  videoNum >= 3 ? style.contentDisabled : ''
                )}
                onClick={e => {
                  if (videoNum >= 3) {
                    e.stopPropagation()
                    message.error(`最多上传3个视频`)
                    return
                  }
                }}
              >
                <i
                  className={`${style.icons} iconfont icon-shangchuanshipin`}
                />
                <div className={style.upload}>添加视频</div>
              </div>
            </VideoUploader>
          )}
        </div>
        <p className={style.addTip}>1. 图片至少上传 5 张，最多可添加 50 张；</p>
        <p className={style.addTip}>
          2. 图片高度在 8192 px 以下，大小不能超过 10 MB，支持
          JPG、PNG和BMP等格式；
        </p>
        {(property_id == 8 || property_id == 11) && (
          <p className={style.addTip}>
            3. 建议视频比例为 16:9，大小不能超过 500 MB，时长不超过 5 分钟，支持
            rmvb、avi 和 mp4 等格式，最多上传3个视频。
          </p>
        )}
        {property_id == 6 &&
          _meal_type != 2 && (
            <div className={style.uninoPhoto}>
              <div className={style.unionTitle}>关联客照</div>
              <div
                className={style.content}
                onClick={() => {
                  this.statisticFunction('example_unopn_photo_add')
                  showKeZhao()
                }}
              >
                <i className={`${style.icons} iconfont icon-tianjiatupian`} />
                <div className={style.upload}>
                  上传客照({kezhaoLen || 0}/{UNINO_PHOTO_LIMIT})
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default Index
